<template>
    

    <b-card no-body>
        <b-modal ref="nicor-billing-modal">
            <template #modal-header>
                <h3>{{$t('ATTENTION_NICOR_CUSTOMERS')}}</h3>
            </template>
            <div>
                <span>{{this.englishPostEffectiveDateNicorMessage}}</span>
                <br />
                <br />
                <span>{{this.spanishPostEffectiveDateNicorMessage}}</span>
            </div>
            <template #modal-footer="{ ok, cancel, hide }">
                <b-button size="sm" variant="success" @click="ok()">
                    OK
                </b-button>
            </template>
        </b-modal>
        <b-card-header><h4>{{$t('PAY_NOW')}}</h4></b-card-header>
        <b-card-body>
            <b-form @submit.stop.prevent>
                <label for="accountNumber">{{$t('ACCOUNT_NUMBER')}}</label>
                <b-input v-model="accountNumber" :state="preValidateAccount" id="account-number"></b-input>
                <b-form-invalid-feedback :state="preValidateAccount">{{$t('VALID_ACCOUNT_NUMBER')}}</b-form-invalid-feedback>
                <label for="zip">{{$t('BILLING_ZIP')}}</label>
                <b-input v-model="zip" :state="preValidateZip" id="zip-code"></b-input>
                <b-form-invalid-feedback :state="preValidateZip">{{$t('VALID_ZIP')}}</b-form-invalid-feedback>
                <label for="phoneLastFour">{{$t('LAST_FOUR_PHONE')}}</label>
                <b-input v-model="phoneLastFour" :state="preValidatePhoneLastFour" id="phone-last-four"></b-input>
                <b-form-invalid-feedback :state="preValidatePhoneLastFour">{{$t('VALID_LAST_FOUR_PHONE')}}</b-form-invalid-feedback>
                <b-button class="mt-3" @click="validate" :disabled="disableSubmit" col>{{$t('SUBMIT')}}</b-button>
            </b-form>

        </b-card-body>
    </b-card>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Repo from '../repo';
    import i18n from '../localization';

    export default {
        name: "QuickPayForm",
        props:['confirm'],
        data: () => ({
            accountNumber: "",
            zip: "",
            phoneLastFour: "",
            nicorBillingEffectiveDateValue: "",
            postEffectiveDateNicorMessageValue: ""
        }),
        computed: {
            ...mapGetters({
                customer: 'lobby/quickPayCustomer'
            }),
            nicorBillingEffectiveDate() {
                return new Date(this.nicorBillingEffectiveDateValue)
            },
            spanishPostEffectiveDateNicorMessage() { return this.postEffectiveDateNicorMessageValue.split('|')[1] },
            englishPostEffectiveDateNicorMessage() { return this.postEffectiveDateNicorMessageValue.split('|')[0] },
            preValidateAccount() {
                if (this.accountNumber.length < 6 || !this.accountNumber.includes("A")) {
                    return false
                }
                return true
            },
            preValidateZip() {
                return this.zip.length == 5
              },
            preValidatePhoneLastFour() {
                if (this.phoneLastFour.length !== 4) {
                    return false
                }
                return true
            },
            disableSubmit() {
                return (!this.preValidateZip || !this.preValidateAccount)
 
            },
            customerRequest() {
                return { ANumber: this.accountNumber, CustomerNumber: this.customer.customerNumber };
            }
        },
        mounted() {
            this.getQuickPaySettings()
        },
        methods: {
            getQuickPaySettings() {
                Repo.QuickPayService.GetAppSetting({ settingName: "Finance.QuickPay.NicorBillingEffectiveDate", settingType: "string" }).then(res => {
                    this.nicorBillingEffectiveDateValue = res?.stringSettingValue
                });
                Repo.QuickPayService.GetAppSetting({ settingName: "Finance.QuickPay.NicorBillingPostEffectiveDateMessage", settingType: "string" }).then(res => {
                    this.postEffectiveDateNicorMessageValue = res?.stringSettingValue
                });
            },
            today() {
                return new Date()
            },
            validate: async function () {
                Repo.QuickPayService.ValidatePhoneNumber({ ExternalKeyValue: this.accountNumber, PhoneNumber: this.phoneLastFour }).then(res => {
                    if (!res.isValid) {
                                var errorMessage = i18n.t('INVALID_LAST_FOUR_PHONE');
                                this.$store.dispatch('shell/addErrorMessages', errorMessage);
                            } else {
                                this.getCustomerTypeCode().then(validCustomerType => {
                                                if (validCustomerType) {
                                                    this.validateAccountInfo().then(validAccountInfo => {
                                                        if (validAccountInfo) {
                                                            this.getBillingAndStatusCodes().then(codes => {
                                                                Repo.QuickPayService.IsNicorCustomer({ ANumber: this.accountNumber }).then(res => {
                                                                    if (res?.isNicorCustomer && (this.today() >= this.nicorBillingEffectiveDate)) {
                                                                        this.$refs["nicor-billing-modal"].show()
                                                                    }
                                                                    else {
                                                                        this.$store.dispatch('lobby/setQuickPayCustomer', codes);
                                                                    }
                                                                })
                                                            })
                                                        }
                                                    })
                                                }
                                            })
                            }
                        })
          
            },
            showNicorBillingMessage() {
                Repo.QuickPayService.IsNicorCustomer({ ANumber: this.accountNumber }).then(res => {
                    if (res?.isNicorCustomer && (this.today() < this.nicorBillingEffectiveDate)) {
                        this.$refs["nicor-billing-modal"].show()
                    }
                })
                return
            },
            getCustomerTypeCode: async function () {
                return Repo.QuickPayService.GetCustomerTypeCode({ AccountNumber: this.accountNumber }).then(res => {
                    this.$store.dispatch('lobby/setQuickPayCustomer', { customerType: res.customerTypeCode });
                    return true;
                });
            },
            getBillingAndStatusCodes: async function () {
                var codes = { billingType: "", statusCode: "", confirmed: true };

                await Repo.QuickPayService.GetBillingTypeCode(this.customerRequest).then(res => {
                                    codes.billingType = res.billingTypeCode
                                });
                await Repo.QuickPayService.GetStatusCode(this.customerRequest).then(res => {                              
                                    codes.statusCode = res.statusCode
                });
                return codes;
            },
            validateAccountInfo: async function () {
                var req = { AccountNumber: this.accountNumber, ZipCode: this.zip };
                return this.$store.dispatch('lobby/validateQuickPayCustomer', req);
            }
        }
};
</script>
